import { ActionTypes } from '../../../constants';

const initialState = {
  list: [],
  selectedThematicSelectionOption: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SELECT_THEMATIC_SELECTION:
      return {
        ...state,
        selectedThematicSelectionOption: action.thematicSelection,
      };
    case ActionTypes.SET_THEMATIC_SELECTION_LIST:
      return {
        ...state,
        list: action.thematicSelectionList,
      };
    case ActionTypes.RENAME_THEMATIC_SELECTION:
      return {
        ...state,
        selectedThematicSelectionOption: {
          ...state.selectedThematicSelectionOption,
          name: action.thematicSelectionName,
        },
      };
    default:
      return state;
  }
};
